
export class CreateEventInput {
    leadId: string;
    text: string;
    userId?: string;
    type: string;
    dateFrom: string;
}
